import { lazy } from "react";

const Home = lazy(() =>
  import("../pages/Home").then(({ Home }) => ({ default: Home }))
);
const Login = lazy(() =>
  import("../pages/Login").then(({ Login }) => ({ default: Login }))
);
const Message = lazy(() =>
  import("../pages/Messages").then(({ Message }) => ({
    default: Message,
  }))
);

const Profile = lazy(() =>
  import("../pages/Profile").then(({ Profile }) => ({
    default: Profile,
  }))
);
export const routeData = [
  {
    component: Home,
    header: "Dashboard",
    path: "/",
    protected: true,
  },
  {
    component: Profile,
    header: "Profile",
    path: "/profile",
    protected: true,
  },
  {
    component: Message,
    header: "",
    path: "/messages",
    protected: true,
  },
  {
    component: Login,
    header: "",
    path: "/login",
    protected: false,
  },
];
